import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskLines = ({ lines, className = "", delay = 0.15, as: Tag = "h1", testid }) => (
  <Tag className={className} data-testid={testid}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span
          className="block will-change-transform"
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Reveal = ({ children, className = "", delay = 0, y = 28, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.85, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Marquee = ({ items, className = "", fast = false, testid }) => (
  <div className={`overflow-hidden whitespace-nowrap ${className}`} data-testid={testid}>
    <div className={`marquee-track inline-flex ${fast ? "fast" : ""}`}>
      {[...items, ...items].map((t, i) => (
        <span key={i} className="inline-flex items-center gap-6 pr-6">
          <span className={i % 2 ? "text-outline" : ""}>{t}</span>
          <svg width="22" height="22" viewBox="0 0 24 24" className="shrink-0" aria-hidden>
            <path d="M12 21V11M12 12c0-6 3.5-9 9-9 0 6.5-4 9-9 9zM12 13c0-5-3-8-8.5-8 0 5.5 3.5 8 8.5 8z" fill="currentColor" />
          </svg>
        </span>
      ))}
    </div>
  </div>
);
